module.exports = __webpack_public_path__ + "static/media/sex-and-vanity.99867bdf.jpg";